import { clsx } from "clsx";
import { ReactNode } from "react";
import "./BaseButton.scss";

interface IBaseButtonProps extends React.ComponentPropsWithRef<"button"> {
  variant?: string;
  children: ReactNode;
}

const PRIMARY = "primary";
const SECONDARY = "secondary";

export const BaseButton = (props: IBaseButtonProps) => {
  const {
    variant = PRIMARY,
    children,
    ...restProps
  } = props;

  const classes = clsx([
    "BaseButton",
    {
      "BaseButton_isPrimary": variant === PRIMARY,
      "BaseButton_isSecondary": variant === SECONDARY
    }
  ]);

  return (
    <button className={classes} {...restProps}>
      <span>{ children }</span>
    </button>
  );
};
